/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Memberships. List of Memberships.
 */
export interface MembershipResult { 
    /**
     * Id Hash. UUI (Unique User Identifier).
     */
    userIdHash?: string;
    /**
     * Id Hash. UCI (Unique Company Identifier).
     */
    companyIdHash?: string;
    /**
     * Company department name.
     */
    companyDepartmentName?: string;
    /**
     * Date Not Before. Format yyyy-MM-dd HH:mm:ss
     */
    notBefore?: string;
    /**
     * Date Not After. Format yyyy-MM-dd HH:mm:ss
     */
    notAfter?: string;
    /**
     * User role in this company.
     */
    role?: string;
    /**
     * User membership number in this company.
     */
    membershipNumber?: string;
    /**
     * User membership type in this company.
     */
    membershipType?: string;
    /**
     * User membership QR or Barcode in this company, it\'s an image, encoded in Base64 format.
     */
    membershipQR?: MembershipResult.MembershipQREnum;
}
export namespace MembershipResult {
    export type MembershipQREnum = '[B@7397c6';
    export const MembershipQREnum = {
        B7397c6: '[B@7397c6' as MembershipQREnum
    };
}


